import { JDSSearchResultTextProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSSearchResultTextProps>
  ): React.FC<JDSSearchResultTextProps> =>
  (props: JDSSearchResultTextProps) => {
    return <Component {...props} />;
  };
